"use strict";

const BrowserEventTracker = require('../BrowserEventTracker');
const newRelicValidator = require('./NewRelicValidator');
const KeyViolationError = require('../KeyViolationError');
const {KEY_VIOLATION_ACTION_TYPE} = require('../constants');

module.exports = (flex = window.flex) => {

    const NewRelicValidator = newRelicValidator(flex);

    class NewRelicTracker extends BrowserEventTracker {
        constructor({
            typeViolationActionType = KEY_VIOLATION_ACTION_TYPE.DO_NOT_TRACK,
            reservedKeyViolationActionType = KEY_VIOLATION_ACTION_TYPE.DO_NOT_TRACK,
            specialKeyViolationActionType = KEY_VIOLATION_ACTION_TYPE.DO_NOT_TRACK,
            actionNameViolationActionType = KEY_VIOLATION_ACTION_TYPE.DO_NOT_TRACK
        } = {}) {
            let { newrelic } = window;
            super(newrelic && newrelic.addPageAction.bind(newrelic), {});

            this.typeViolationActionType = typeViolationActionType;
            this.reservedKeyViolationActionType = reservedKeyViolationActionType;
            this.specialKeyViolationActionType = specialKeyViolationActionType;
            this.actionNameViolationActionType = actionNameViolationActionType;
        }

        track(eventName, values) {
            let validity = NewRelicValidator.validate(eventName, values),
                canTrack = true;

            if (!validity.isValid) {
                let invalid = this.handleInvalid(validity, values);
                canTrack = invalid.canTrack;
                invalid.errors.forEach(error => KeyViolationError.inform(error));
            }

            if (canTrack) {
                super.track(eventName, values);
            }
        }

        handleInvalid(validity, values) {
            let errors = [],
                canTrack = !(
                    (validity.isReservedKeyInvalid && this.reservedKeyViolationActionType === KEY_VIOLATION_ACTION_TYPE.DO_NOT_TRACK) ||
                    (validity.isSpecialKeyInvalid && this.specialKeyViolationActionType === KEY_VIOLATION_ACTION_TYPE.DO_NOT_TRACK) ||
                    (validity.isTypeInvalid && this.typeViolationActionType === KEY_VIOLATION_ACTION_TYPE.DO_NOT_TRACK) ||
                    (validity.isEventNameInvalid && this.actionNameViolationActionType === KEY_VIOLATION_ACTION_TYPE.DO_NOT_TRACK)
                );

            if (validity.reservedKeyViolations.length) {
                let level = this.reservedKeyViolationActionType === KEY_VIOLATION_ACTION_TYPE.DO_NOT_TRACK ? KeyViolationError.LEVEL.ERROR : KeyViolationError.LEVEL.WARN;
                errors.push(new KeyViolationError({ level, message: `ReservedKeyViolation - These keys are prohibited: [ ${validity.reservedKeyViolations.join(' | ')} ]` }))
            }
            if (validity.specialKeyViolations.length) {
                let level = this.specialKeyViolationActionType === KEY_VIOLATION_ACTION_TYPE.DO_NOT_TRACK ? KeyViolationError.LEVEL.ERROR : KeyViolationError.LEVEL.WARN;
                errors.push(new KeyViolationError({ level, message: `SpecialKeyViolation - These keys should be avoided: [ ${validity.specialKeyViolations.join(' | ')} ]` }))

                if (this.specialKeyViolationActionType === KEY_VIOLATION_ACTION_TYPE.ESCAPE) {
                    NewRelicTracker.escapeSpecialKeys(values, validity.specialKeyViolations);
                }
            }
            if (validity.typeViolations.length) {
                let level = this.typeViolationActionType === KEY_VIOLATION_ACTION_TYPE.DO_NOT_TRACK ? KeyViolationError.LEVEL.ERROR : KeyViolationError.LEVEL.WARN;
                errors.push(new KeyViolationError({ level, message: `TypeViolation - [ ${validity.typeViolations.join(' | ')} ]` }))
            }
            if (validity.isEventNameInvalid) {
                let level = this.actionNameViolationActionType === KEY_VIOLATION_ACTION_TYPE.DO_NOT_TRACK ? KeyViolationError.LEVEL.ERROR : KeyViolationError.LEVEL.WARN;
                errors.push(new KeyViolationError({ level, message: `EventNameViolation for event name \`${validity.eventName}\` - Event Name must be one of the following: \n[ ${flex.tracking.actionNames.join(', ')} ]` }))
            }

            return {
                canTrack,
                errors
            }
        }

        static escapeSpecialKeys(map, specialKeys = []) {
            let keyMap = Object.keys(map).reduce((keyMap, key) => {
                keyMap[key.toLowerCase()] = key;

                return keyMap;
            }, {});

            specialKeys.forEach(key => {
                let newKey = `\`${keyMap[key]}\``;
                map[newKey] = map[keyMap[key]];

                delete map[keyMap[key]];
            });
        }
    }

    return NewRelicTracker;
};